
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/serwis-aut-dostawczych/[tytul]/[shortid]/[lang]",
      function () {
        return require("private-next-pages/serwis-aut-dostawczych/[tytul]/[shortid]/[lang]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/serwis-aut-dostawczych/[tytul]/[shortid]/[lang]"])
      });
    }
  